import React from 'react';
import _ from '@dh-fe/translate';
import SignUpButton from 'components/Button/SignUpButton';
import bgDesktopJpgOranum from './assets/bgOranum.jpg';
import bgDesktopWebpOranum from './assets/bgOranum.webp';
import bgMobileJpgOranum from './assets/bgMobileOranum.jpg';
import bgMobileWebpOranum from './assets/bgMobileOranum.webp';

interface Content {
    bg: string;
    bgMobile: string;
    bgCompress: string;
    bgMobileCompress: string;
    button: JSX.Element;
}

const oranumContent: Content = {
    button: <SignUpButton>{_`Register Now`}</SignUpButton>,
    bg: bgDesktopJpgOranum,
    bgMobile: bgMobileJpgOranum,
    bgCompress: bgDesktopWebpOranum,
    bgMobileCompress: bgMobileWebpOranum,
};
// eslint-disable-next-line import/prefer-default-export
export const getContent = (): Content => {
    return oranumContent;
};
